var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandmarksPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.2264C25 21.9448 12.5 31.9767 12.5 31.9767C12.5 31.9767 0 21.9448 0 12.2264C0 5.47395 5.59644 0 12.5 0C19.4036 0 25 5.47395 25 12.2264Z",
    fill: "#DE303B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#DE303B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91148 7.41284H14.9279C16.3353 7.41284 17.4468 8.59862 17.4468 10.0278C17.4468 11.2463 16.4984 12.2616 15.2927 12.2616C14.253 12.2616 13.438 11.3857 13.438 10.3407C13.438 9.44139 14.1403 8.68319 15.0406 8.68319C15.8289 8.68319 16.4356 9.34607 16.4356 10.1238C16.4356 10.8032 15.9053 11.3817 15.2156 11.3817C14.8417 11.3817 14.521 11.1886 14.329 10.9018C14.5184 11.2662 14.8857 11.5058 15.2927 11.5058C16.05 11.5058 16.691 10.8605 16.691 10.0278C16.691 8.98444 15.8869 8.16865 14.9279 8.16865H9.90855C8.95152 8.16364 8.14449 8.98086 8.14449 10.0247C8.14449 10.8574 8.78547 11.5027 9.54283 11.5027C9.94979 11.5027 10.3171 11.2631 10.5065 10.8987C10.3145 11.1855 9.99382 11.3786 9.61993 11.3786C8.93019 11.3786 8.39986 10.8001 8.39986 10.1207C8.39986 9.33841 9.01096 8.68009 9.79488 8.68009C10.6952 8.68009 11.3975 9.43829 11.3975 10.3376C11.3975 11.3826 10.5825 12.2586 9.54283 12.2586C8.33712 12.2586 7.38867 11.2432 7.38867 10.0247C7.38867 8.59636 8.50264 7.40605 9.91148 7.41284ZM10.5784 9.99395C10.4493 9.66047 10.1386 9.4359 9.79488 9.4359C9.4579 9.4359 9.15567 9.72569 9.15567 10.1207C9.15567 10.4143 9.37854 10.6228 9.61993 10.6228C9.78125 10.6228 9.94184 10.4794 9.94184 10.2695C9.94184 10.0608 10.111 9.89157 10.3198 9.89157C10.4198 9.89157 10.5108 9.93046 10.5784 9.99395ZM14.2571 9.99704C14.3247 9.93355 14.4157 9.89466 14.5157 9.89466C14.7244 9.89466 14.8936 10.0639 14.8936 10.2726C14.8936 10.4825 15.0542 10.6259 15.2156 10.6259C15.4569 10.6259 15.6798 10.4174 15.6798 10.1238C15.6798 9.73042 15.3791 9.439 15.0406 9.439C14.6969 9.439 14.3862 9.66357 14.2571 9.99704Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13281 13C9.13281 12.7913 9.30201 12.6221 9.51072 12.6221H15.3247C15.5334 12.6221 15.7026 12.7913 15.7026 13C15.7026 13.2087 15.5334 13.3779 15.3247 13.3779H9.51072C9.30201 13.3779 9.13281 13.2087 9.13281 13Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58008 13.9535C9.58008 13.7448 9.74927 13.5756 9.95799 13.5756L14.8775 13.5756C15.0862 13.5756 15.2554 13.7448 15.2554 13.9535C15.2554 14.1622 15.0862 14.3314 14.8775 14.3314L9.95799 14.3314C9.74927 14.3314 9.58008 14.1622 9.58008 13.9535Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0928 14.9477C10.3015 14.9477 10.4707 15.1169 10.4707 15.3256L10.4707 18.2094C10.4707 18.4181 10.3015 18.5873 10.0928 18.5873C9.88408 18.5873 9.71489 18.4181 9.71489 18.2094L9.71489 15.3256C9.71489 15.1169 9.88408 14.9477 10.0928 14.9477Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0225 14.9477C11.2312 14.9477 11.4004 15.1169 11.4004 15.3256L11.4004 18.2094C11.4004 18.4181 11.2312 18.5873 11.0225 18.5873C10.8138 18.5873 10.6446 18.4181 10.6446 18.2094L10.6446 15.3256C10.6446 15.1169 10.8138 14.9477 11.0225 14.9477Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.419 14.9477C12.6277 14.9477 12.7969 15.1169 12.7969 15.3256L12.7969 18.2094C12.7969 18.4181 12.6277 18.5873 12.419 18.5873C12.2103 18.5873 12.0411 18.4181 12.0411 18.2094L12.0411 15.3256C12.0411 15.1169 12.2103 14.9477 12.419 14.9477Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8135 14.9477C14.0222 14.9477 14.1914 15.1169 14.1914 15.3256L14.1914 18.2094C14.1914 18.4181 14.0222 18.5873 13.8135 18.5873C13.6048 18.5873 13.4356 18.4181 13.4356 18.2094L13.4356 15.3256C13.4356 15.1169 13.6048 14.9477 13.8135 14.9477Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7432 14.9477C14.9519 14.9477 15.1211 15.1169 15.1211 15.3256L15.1211 18.2094C15.1211 18.4181 14.9519 18.5873 14.7432 18.5873C14.5345 18.5873 14.3653 18.4181 14.3653 18.2094L14.3653 15.3256C14.3653 15.1169 14.5345 14.9477 14.7432 14.9477Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandmarksPin);
export default __webpack_public_path__ + "static/media/landmarks-pin.dcefb82f1f3b81b0e32fd8db7b159cf3.svg";
export { ForwardRef as ReactComponent };